__turbopack_context__.v({
  "section": "article-image-module-scss-module__DGemhq__section",
});
